export const TABS = {
  ROADMAP: '/roadmap',
  MANIFESTO: '/what-is-ttr',
  MINT: '/gen1-mint',
  TERMS: '/legal/terms-conditions'
};
